var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hiv-quiz',{attrs:{"question":"Your doctors will talk to your parents/caregivers about your HIV status/test result.","answer":false}})}
var staticRenderFns = []

export { render, staticRenderFns }